import NotFoundLogo from 'assets/images/not_found/404.svg';
import styles from 'styles/NotFound.module.css';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

const NotFound: React.FC = () => {
  return (
    <div className={styles["not-found-background"]}>
      <Helmet>
        <title>Not Found | AREA CUP</title>
        <meta property="og:title" content="Not Found | AREA CUP" />
        <meta name="twitter:title" content="Not Found | AREA CUP" />
      </Helmet>
      <div className={styles["not-found-container"]}>
        <img src={NotFoundLogo} draggable="false" alt="Not Found" />
        <div className={styles["not-found-message"]}>
          <h3>お探しのページは存在しませんでした。</h3>
          <p>アクセスしようとしたページは現在表示することができません。</p>
          <p>URLが正しいかどうかご確認ください。</p>
          <p>ページが削除されている、または移動している可能性もございます。</p>
          <Link to="/" className={styles["top-button"]}>TOPへ戻る →</Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
